/**
 * @file routes/_app/risk-assessment/route.tsx
 * @description 風險評估 Layout 路由（M2）。
 */

import { Outlet, createFileRoute } from '@tanstack/react-router';

/** TanStack Router 路由定義 */
export const Route = createFileRoute('/_app/risk-assessment')({
  component: () => <Outlet />,
});
